import template from './commissionEdit.template.html';

export default {
  bindings: {
    onFinished: '&'
  },
controller: class controller {
    constructor(
      $q,
      $rootScope,
      $mdDialog,
      $mdMedia,
      $filter,
      eventService,
      commissionService,
      organizationsService,
      accountsService,
      partnersService,
      uiService,
      Commission,
      CommissionSplit,
      COMMISSION,
      ACCOUNT
    ) {
      'ngInject';
      /*
       * Controller Model
       * --------------------------------------------------------------------------------
       */
      const ctrl = this;
      ctrl.CurrentCurrency = null;
      ctrl.$mdDialog = $mdDialog;
      ctrl.$mdMedia = $mdMedia;
      ctrl.destroyWatch = null;
      ctrl.isReady = false;

      /*
       * Methods
       * --------------------------------------------------------------------------------
       */
      ctrl.initialize = () => {
        ctrl.CurrentCurrency = $rootScope.CurrentCurrency;
        ctrl.CurrentOrganization = $rootScope.CurrentOrganization;

        ctrl.destroyWatch = eventService.onCommissionEdit((_params) => {
          $mdDialog
            .show({
              targetEvent: _params.event,
              locals: {
                commission: _params.commission
                  ? angular.copy(_params.commission)
                  : Commission.blank(),
                currency: ctrl.CurrentCurrency,
                isMedia: ctrl.$mdMedia
              },
              template,
              controllerAs: '$ctrl',
              controller(commission, currency, isMedia) {
                const ctr = this;
                ctr.organization = $rootScope.CurrentOrganization;
                ctr.commission = commission;
                ctr.currency = currency;
                ctr.GoB = [];
                ctr.accounts = [];
                ctr.partners = [];

                ctr.IsMedia = isMedia;
                ctr.split = null;
                ctr.isEditingCommission = _.isUuid(commission.id);
                ctr.splitAdd = () => {
                  const split = CommissionSplit.blank();
                  split.chipsAssigned = [];
                  if (_.some(ctr.commission.splits, (s) => s.isRemainder)) {
                    ctr.commission.splits.splice(ctr.commission.splits.length - 1, 0, split);
                  } else {
                    ctr.commission.splits.push(split);
                  }
                };
                ctr.subSplitAdd = (index) => {
                  const split = CommissionSplit.blank();
                  split.chipsAssigned = [];
                  if (_.some(ctr.commission.splits[index].splits, (s) => s.isRemainder)) {
                    ctr.commission.splits[index].splits.splice(
                      ctr.commission.splits[index].splits.length - 1,
                      0,
                      split
                    );
                  } else {
                    ctr.commission.splits[index].splits.push(split);
                  }
                };
                ctr.subSubSplitAdd = (parentIndex, index) => {
                  const split = CommissionSplit.blank();
                  split.chipsAssigned = [];
                  if (
                    _.some(
                      ctr.commission.splits[parentIndex].splits[index].splits,
                      (s) => s.isRemainder
                    )
                  ) {
                    ctr.commission.splits[parentIndex].splits[index].splits.splice(
                      ctr.commission.splits[parentIndex].splits[index].splits.length - 1,
                      0,
                      split
                    );
                  } else {
                    ctr.commission.splits[parentIndex].splits[index].splits.push(split);
                  }
                };
                ctr.splitRemove = (index) => {
                  ctr.commission.splits.splice(index, 1);
                };
                ctr.subSplitRemove = (parentIndex, index) => {
                  ctr.commission.splits[parentIndex].splits.splice(index, 1);
                };
                ctr.subSubSplitRemove = (parentParentIndex, parentIndex, index) => {
                  ctr.commission.splits[parentParentIndex].splits[parentIndex].splits.splice(
                    index,
                    1
                  );
                };
                ctr.canGetRemainderOfCommission = (split, index) =>
                  split &&
                  split.upfront !== '0' &&
                  split.trail !== '0' &&
                  split.splits &&
                  split.splits[index - 1] &&
                  split.splits[index - 1].upfront !== '0' &&
                  split.splits[index - 1].trail !== '0';
                ctr.toggleIsRemainder = (splitToEdit) => {
                  const split = splitToEdit;
                  split.upfront = 0;
                  split.upfrontPercentage = 0;
                  split.trail = 0;
                  split.trailPercentage = 0;
                  split.isRemainder = !split.isRemainder;
                };
                ctr.chips = [].concat(COMMISSION.PAYEE);
                ctr.chipsFilter = (query) =>
                  query
                    ? $filter('filter')(
                        ctr.chips,
                        (c) => c.name.toLowerCase().indexOf(query.toLowerCase()) > -1
                      )
                    : [];

                const self = this;
                $q.all([
                  organizationsService.getRoot(),
                  organizationsService.getGroup(),
                  organizationsService.getAvailableGoB({ isActive: true }),
                  accountsService.getAvailable({ isActive: true, fields: ACCOUNT.FIELDS.LIST }),
                  partnersService.getAvailable({ isActive: true, fields: ACCOUNT.FIELDS.CHIPS })
                ]).then((data) => {
                  const root = data[0];
                  const group = data[1];
                  const GoB = data[2];
                  const accounts = data[3];
                  const partners = data[4];
                  self.root = root;
                  self.group = group;
                  self.GoB = GoB;
                  self.accounts = accounts;
                  self.usersAsPartners = accounts;
                  self.partners = partners;
                  if (self.root && self.root.id) {
                    if (!_.find(self.chips, (ch) => ch.id === self.root.id)) {
                      self.chips = self.chips.concat({
                        id: self.root.id,
                        name: self.root.getName(),
                        email: 'ORGANIZATION',
                        image: self.root.organization.logo
                      });
                    }
                  }
                  if (self.group && self.group.id) {
                    if (!_.find(self.chips, (ch) => ch.id === self.group.id)) {
                      self.chips = self.chips.concat({
                        id: self.group.id,
                        name: self.group.getName(),
                        email: 'ORGANIZATION',
                        image: self.group.organization.logo
                      });
                    }
                  }
                  if (self.organization && self.organization.id) {
                    if (!_.find(self.chips, (ch) => ch.id === self.organization.id)) {
                      self.chips = self.chips.concat({
                        id: self.organization.id,
                        name: self.organization.getName(),
                        email: 'ORGANIZATION',
                        image: self.organization.organization.logo
                      });
                    }
                  }
                  self.chips = self.chips.concat(
                    self.GoB.map((org) => ({
                      id: org.id,
                      name: org.getName(),
                      email: 'ORGANIZATION',
                      image: org.organization.logoClient
                    }))
                  );
                  self.chips = self.chips.concat(
                    self.accounts.map((account) => ({
                      id: account.id,
                      name: account.getName(),
                      email: 'USER',
                      image: account.user.avatar
                    }))
                  );
                  self.chips = self.chips.concat(
                    self.partners.map((partner) => ({
                      id: partner.id,
                      name: partner.getName(),
                      email: 'PARTNER',
                      image: partner.user.avatar
                    }))
                  );
                  self.chips = self.chips.concat(
                    self.usersAsPartners.map((partner) => ({
                      id: partner.id,
                      name: partner.getName(),
                      email: 'USER_AS_PARTNER',
                      image: partner.user.avatar
                    }))
                  );

                  if (
                    self.commission &&
                    self.commission.splits &&
                    self.commission.splits.length
                  ) {
                    _.forEach(self.commission.splits, (splitToEdit) => {
                      const split = splitToEdit;
                      split.chipsAssigned = [];
                      if (split.idPayee && split.payeeType) {
                        split.chipsAssigned = _.filter(
                          self.chips,
                          (chip) =>
                            chip.email === split.payeeType.toUpperCase() &&
                            chip.id === split.idPayee
                        );
                      }
                      if (split.splits && split.splits.length) {
                        _.forEach(split.splits, (subSplitToEdit) => {
                          const subSplit = subSplitToEdit;
                          subSplit.chipsAssigned = [];
                          if (subSplit.idPayee && subSplit.payeeType) {
                            subSplit.chipsAssigned = _.filter(
                              self.chips,
                              (chip) =>
                                chip.email === subSplit.payeeType.toUpperCase() &&
                                chip.id === subSplit.idPayee
                            );
                          }
                          if (subSplit.splits && subSplit.splits.length) {
                            _.forEach(subSplit.splits, (subSubSplitToEdit) => {
                              const subSubSplit = subSubSplitToEdit;
                              subSubSplit.chipsAssigned = [];
                              if (subSubSplit.idPayee && subSubSplit.payeeType) {
                                subSubSplit.chipsAssigned = _.filter(
                                  self.chips,
                                  (chip) =>
                                    chip.email === subSubSplit.payeeType.toUpperCase() &&
                                    chip.id === subSubSplit.idPayee
                                );
                              }
                            });
                          }
                        });
                      }
                    });
                  }

                  self.isReady = true;
                });

                ctr.confirm = () => {
                  if (
                    self.commission.isUpfrontPercentageValid() &&
                    self.commission.isTrailPercentageValid() &&
                    self.commission.name !== ''
                  ) {
                    _.forEach(self.commission.splits, (splitToEdit) => {
                      const split = splitToEdit;
                      split.name = '';
                      split.idPayee = '';
                      split.payeeType = '';
                      if (
                        split.chipsAssigned &&
                        split.chipsAssigned.length &&
                        split.chipsAssigned[0]
                      ) {
                        split.name = split.chipsAssigned[0].name;
                        split.idPayee = split.chipsAssigned[0].id;
                        split.payeeType = split.chipsAssigned[0].email.toUpperCase();
                        delete split.chipsAssigned;
                      }
                      if (split.splits && split.splits.length) {
                        _.forEach(split.splits, (subSplitToEdit) => {
                          const subSplit = subSplitToEdit;
                          subSplit.name = '';
                          subSplit.idPayee = '';
                          subSplit.payeeType = '';
                          if (
                            subSplit.chipsAssigned &&
                            subSplit.chipsAssigned.length &&
                            subSplit.chipsAssigned[0]
                          ) {
                            subSplit.name = subSplit.chipsAssigned[0].name;
                            subSplit.idPayee = subSplit.chipsAssigned[0].id;
                            subSplit.payeeType = subSplit.chipsAssigned[0].email.toUpperCase();
                            delete subSplit.chipsAssigned;
                          }
                          if (subSplit.splits && subSplit.splits.length) {
                            _.forEach(subSplit.splits, (subSubSplitToEdit) => {
                              const subSubSplit = subSubSplitToEdit;
                              subSubSplit.name = '';
                              subSubSplit.idPayee = '';
                              subSubSplit.payeeType = '';
                              if (
                                subSubSplit.chipsAssigned &&
                                subSubSplit.chipsAssigned.length &&
                                subSubSplit.chipsAssigned[0]
                              ) {
                                subSubSplit.name = subSubSplit.chipsAssigned[0].name;
                                subSubSplit.idPayee = subSubSplit.chipsAssigned[0].id;
                                subSubSplit.payeeType = subSubSplit.chipsAssigned[0].email.toUpperCase();
                                delete subSubSplit.chipsAssigned;
                              }
                            });
                          }
                        });
                      }
                    });
                    $mdDialog.hide(self.commission);
                  } else if (
                    !ctr.commission.isUpfrontPercentageValid() ||
                    !ctr.commission.isTrailPercentageValid()
                  ) {
                    uiService.toast({
                      text: {
                        p1: 'Total percentage',
                        p2: 'cannot be',
                        p3: 'more than 100 percent'
                      },
                      warn: true
                    });
                  } else {
                    uiService.toast({
                      text: {
                        p1: 'Commission group',
                        p2: 'name',
                        p3: 'is required'
                      },
                      warn: true
                    });
                  }
                };
                ctr.cancel = () => {
                  $mdDialog.cancel();
                };
                if (!ctr.isEditingCommission) {
                  ctr.splitAdd();
                }
              }
            })
            .then((res) => {
              const commission = res;
              if (!_.isUuid(commission.id)) {
                commissionService.createCommission(commission).then((data) => {
                  if (data.status) {
                    commission.id = data.id;
                    commission.isNew = true;
                    ctrl.onFinished({ commission });
                    uiService.toast({
                      text: {
                        p1: 'Commission group',
                        p2: commission.getName(),
                        p3: 'has been added'
                      }
                    });
                  }
                });
              } else {
                commissionService.updateCommission(commission).then((data) => {
                  if (data.status) {
                    ctrl.onFinished({ commission });
                    uiService.toast({
                      text: {
                        p1: 'Commission group',
                        p2: commission.getName(),
                        p3: 'has been updated'
                      }
                    });
                  }
                });
              }
            });
        });
      };

      /*
       * Execute when all bindings are completed
       * --------------------------------------------------------------------------------
       */
      ctrl.$onInit = () => {
        ctrl.initialize();
      };

      /*
       * Execute when component is not necessary anymore
       * --------------------------------------------------------------------------------
       */
      ctrl.$onDestroy = () => {
        ctrl.destroyWatch();
      };
    }
  }
};
